<template>
<div style="background-color: whitesmoke; width: 90%; margin: 0 auto;">
    <fieldset v-if="typeof question.actions=='function'" style="border: 1px solid lightgrey; border-radius: 5px;">
        <legend>QID: {{question.config.id}}</legend>
        <h4 align='center' style="color:red;"> *** QUESTION HAS ON-ANSWER LOGIC ***</h4>
    </fieldset>

    <fieldset v-if="question.display_triggers && question.display_triggers.length>0" style="border: 1px solid; border-radius: 5px;" :style="{'border-color':question.display===true ? 'green' : 'lightgrey'}">
        <legend>QID: {{question.config.id}}</legend>
        
        <table :class="$style.logicTable">
            <tbody>
                <template v-for="(rules, index) in question.display_triggers">
                    <tr :key="'trigger_or_'+index" v-if="index>0">
                        <th colspan='100%'>
                            <div  style="width: 100px; margin: 0 auto; font-size: 1.3em; border: 1px solid lightgrey;">OR</div>
                        </th>
                    </tr>
                    <tr :key="'trigger_'+index">
                        <td>
                            <table :class="$style.logicTable">
                                <thead>
                                    <tr>
                                        <th style="width:20%;">RULE</th>
                                        <th style="width:20%;"></th>
                                        <th style="width:20%;"></th>
                                        <th style="width:20%;">REFERENCE QUESTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(rule,name,rule_index) in rules">
                                        <tr :key="'rule_or_'+rule_index" v-if="rule_index>0">
                                            <th colspan='100%'>
                                                <div  style="width: 100px; margin: 0 auto; font-size: 1em;">AND</div>
                                            </th>
                                        </tr>
                                        <tr :key="'rule_'+name">
                                            <td>
                                                {{name}}
                                            </td>

                                            <th :class="$style.triggered">
                                                <template v-if="rule.result===true">
                                                    {{rule.result}}
                                                </template>
                                            </th>

                                            <th>
                                                <template v-if="rule.result===false">
                                                    {{rule.result}}
                                                </template>
                                            </th>

                                            <td>
                                                <ul v-if="ruleConfig(name).type=='question'">
                                                    <li>
                                                        <v-btn @click="questionMap[ruleConfig(name).ref_id].focus()" :color="questionMap[ruleConfig(name).ref_id].display===true ? 'primary' : ''">
                                                            Question: {{ruleConfig(name).ref_id}} => 
                                                            [group: {{ruleConfig(name).group_id}}] ==>
                                                            <span v-for="(operator, index) in operatorConfig.list"  v-if="ruleConfig(name)[operator]">{{operator}}::{{ruleConfig(name)[operator]}}</span>
                                                            <span v-if="ruleConfig(name).input_id">{{ruleConfig(name).input_id}}</span>
                                                            <span v-if="ruleConfig(name).advanced">PROGRAMMED</span>
                                                            
                                                        </v-btn>
                                                    </li>
                                                    <li>
                                                        Type: {{ruleConfig(name).question_type}}
                                                    </li>
                                                    <li>
                                                        Value: {{questionMap[ruleConfig(name).ref_id].value[ruleConfig(name).group_id]}}
                                                    </li>
                                                </ul>
                                                <!-- <ul>
                                                    <template v-for="(param,param_index) in ruleConfig(name)">
                                                        <li :key="'param_'+param_index" v-if="param && (param_index!='name')">
                                                            {{param_index}} : <v-btn v-if="param_index=='ref_id'" @click="questionMap[param].focus()">{{param}}</v-btn> <span v-else>{{param}}</span>
                                                            <template v-if="param_index=='ref_id' && questionMap[param].value[ruleConfig(name).group_id]">
                                                                <hr> 
                                                                CURRENT GROUP [{{ruleConfig(name).group_id}}] ANSWER: {{questionMap[param].value[ruleConfig(name).group_id]}} 
                                                                => {{questionMap[ruleConfig(name).ref_id].configMap[ruleConfig(name).group_id].inputs[questionMap[param].value[ruleConfig(name).group_id]] ? questionMap[ruleConfig(name).ref_id].configMap[ruleConfig(name).group_id].inputs[questionMap[param].value[ruleConfig(name).group_id]].label[$language()] : '---'}}
                                                            </template>

                                                            <template v-if="param_index=='contains' && typeof ruleConfig.name.contains!='Object'">
                                                                => {{questionMap[ruleConfig(name).ref_id].configMap[ruleConfig(name).group_id].inputs[ruleConfig(name).contains] ? questionMap[ruleConfig(name).ref_id].configMap[ruleConfig(name).group_id].inputs[ruleConfig(name).contains].label[$language()] : '---'}}
                                                            </template>
                                                        </li>
                                                    </template>
                                                </ul> -->
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </fieldset>
</div>  
</template>

<script>
import OperatorConfig from '@/components/Survey/helpers/OperatorConfig.js';

export default {
    name: 'logic-debugger',
    props: {
        questionMap: {
            type: Object,
            required: true
        },        
        question: {
            type: Object,
            required: true
        },
        surveyRules: {
            type: Object,
            required: true
        }
    },
    data: function(){
        return {
            operatorConfig: OperatorConfig
        }
    },
    methods: {
        ruleConfig: function(name){
            var triggers = this.surveyRules.display[this.question.config.id];
            var matchedRule = false;

            if(triggers){
                for(let i=0; i<triggers.length; i++){
                    var rules = triggers[i];
    
                    for(let r=0; r<rules.length; r++){
                        var rule = rules[r];
    
                        if(rule.name == name){
                            matchedRule = rule;
                            break;
                        }
                    }
    
                    if(matchedRule){break;}
                }
            }

            return  matchedRule;
        }        
    }
}
</script>

<style module>
.logicTable{
    width: 100%
}

.logicTable thead th{
    border-bottom: 1px solid lightgrey;
    margin-bottom: 10px;
}

.triggered{
    text-transform: uppercase;
    font-size: 1.2em;
    font-weight: bold;
    color: green;
}
</style>